<template>
    <div class="description" v-if="baseInfo != null">
        <div class="container">
            <div class="row">
                <div class="site-description col-sm-12 col-md-12 col-lg-4">
                    <header class="card-header">
                        <h3 class="site-title"> فروشگاه اینترنتی {{baseInfo.ShopName}} </h3>
                    </header>
                    <p class="p_justify" v-html="baseInfo.AboutShortUs">
                    </p>
                </div>
                <div class="col-12 col-lg-2 col-md-6">
                    <div class="site-description">
                        <header class="card-header">
                            <h3 class="site-title">ناوبری</h3>
                        </header>
                        <ul class="footer-menu">
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/aboutUs" title="درباره ما">درباره ما</router-link>
                            </li>
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/contactUs" title="پیغام به مدیریت">پیغام به مدیریت</router-link>
                            </li>
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/rules" title="قوانین و مقررات">قوانین و مقررات</router-link>
                            </li>
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/privacy" title="حریم خصوصی">حریم خصوصی</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-lg-2 col-md-6">
                    <div class="site-description">
                        <header class="card-header">
                            <h3 class="site-title">دسترسی سریع</h3>
                        </header>
                        <ul class="footer-menu">
                            <li  v-if="isUserLogined">
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/orders" title="حساب کاربری">حساب کاربری</router-link>
                            </li>
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/siteGuide" title="راهنمای سایت">راهنمای سایت</router-link>
                            </li>
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <router-link to="/commonGuestions" title="سوالات متداول">سوالات متداول</router-link>
                            </li>
                            <li>
                                <i class="fa fa-caret-left" aria-hidden="true"></i>
                                <a href="https://irannmart.com/blog" title="بلاگ">بلاگ</a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-lg-4 col-md-6">
                    <div class="site-description">
                        <header class="card-header">
                            <h3 class="site-title">مجوزها</h3>
                        </header>
                        <div class="bsymbol symbol-main margin-t-10">
                            <a v-if="baseInfo.EnamadLink1 != '' && baseInfo.EnamadPicPath1 != null" style="background: unset; border:unset" target="_blank" :href="baseInfo.EnamadLink1"><img :src="baseInfo.EnamadPicPath1" :alt="baseInfo.ShopName"></a>
                            <a v-if="baseInfo.EnamadLink2 != '' && baseInfo.EnamadPicPath2 != null" style="background: unset; border:unset" target="_blank" :href="baseInfo.EnamadLink2"><img :src="baseInfo.EnamadPicPath2" :alt="baseInfo.ShopName"></a>
                            <a v-if="baseInfo.EnamadLink3 != ''  && baseInfo.EnamadPicPath3 != null" style="background: unset; border:unset" target="_blank" :href="baseInfo.EnamadLink3"><img :src="baseInfo.EnamadPicPath3" :alt="baseInfo.ShopName"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            redirectToPage(href) {
                window.open(href, "_blank");
            }
        }, beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        }
    }
</script>

<style scoped>
    .symbol-main {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .footer-menu li {
        padding-right: 7px;
        line-height: 2.2;
    }

        .footer-menu li .fa:before {
            color: #8e1717;
        }

    footer.main-footer .description .site-description .site-title {
        margin-bottom: 3px;
    }

    .widget .card-header, .brand-slider .card-header {
        background-color: unset;
        border-bottom: unset;
    }

    .card-header {
        background-color: unset;
    }

    .widget {
        border-radius: unset;
        box-shadow: unset;
        background: unset;
        padding: 15px;
    }

    .footer-social a .fa {
        padding-left: 3px !important;
    }

    .footer-social a {
        padding-left: 10px;
    }

    .text-center {
        text-align: center;
    }

    .footer-menu li span.title {
        color: #888;
        font-weight: bold;
        font-size: 17px;
    }

    .footer-menu {
        padding-top: 7px;
    }

        .footer-menu li .fa {
            font-size: 18px;
            vertical-align: middle;
            padding-left: 8px;
            color: #888;
        }

        .footer-menu li a {
            color: #777777;
            font-size: 13px;
            font-weight: 400;
        }

        .p_justify{
            text-align: justify;
        }


</style>